import React, { useState, useEffect } from "react";
import Conect from "../../../../../Api/Conect";
import NotificationsAlert from "../../../../services/NotificationsAlert";
import "./ChipTable.css";
const initialFormState = {
    id: "",
    phoneNumber: "",
    pin: "",
    pun: "",
    punk: "",
    operatorId: 0,
};

const ChipCrud = ({ token, operators }) => {
    const [chips, setChips] = useState([]);
    const [form, setForm] = useState(initialFormState);
    const [editing, setEditing] = useState(false);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        fetchChips();
    }, []);

    const fetchChips = async () => {
        try {
            const { data } = await Conect.get(`/Y2hpcHNsaXN0${token}`);

            const merged = data.data.map((chip) => ({
                ...chip,
                operator:
                    operators.find((op) => op.id === chip.operator_id)?.name ||
                    "Unknown",
            }));

            setChips(merged);
        } catch (err) {
            console.error(err);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        try {
            let res;

            if (editing) {
                res = await Conect.put(`/Y2hpcHN1cGRhdGU=${token}`, {
                    id: form.id,
                    phoneNumber: form.phone_number,
                    pin: form.pin,
                    pun: form.pun,
                    punk: form.punk,
                    operatorId: form.operator_id,
                });
            } else {
                res = await Conect.post(`/Y2hpcHNjcmVhdA==${token}`, {
                    id: form.id,
                    phoneNumber: form.phone_number,
                    pin: form.pin,
                    pun: form.pun,
                    punk: form.punk,
                    operatorId: form.operator_id,
                });
            }

            if (res.data?.erro) {
                NotificationsAlert("warning", "Atenção", res.data.msg);
            } else {
                NotificationsAlert("success", "Sucesso!", res.data.msg);
            }

            fetchChips();
            setShowModal(false);
        } catch (err) {
            NotificationsAlert("error", "Erro", "Falha ao salvar");
        }
    };

    const handleDelete = async (id) => {
        const confirm = window.confirm("Remover chip?");
        if (!confirm) return;

        const res = await Conect.delete(`/ZGVsZXRlY2hpcHM=${token}/${id}`);

        if (!res.data?.erro) {
            fetchChips();
        }
    };

    const openModal = (chip = null) => {
        setForm(chip || initialFormState);
        setEditing(!!chip);
        setShowModal(true);
    };

    return (
        <div className="chip-manager">
            <h2>Gerenciamento de Chips</h2>

            <button className="chip-btns-block" onClick={() => openModal()}>
                Adicionar Chip
            </button>

            <table className="chip-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Phone Number</th>
                        <th>PIN</th>
                        <th>PUN</th>
                        <th>PUNK</th>
                        <th>Operator</th>
                        <th>Ações</th>
                    </tr>
                </thead>

                <tbody>
                    {chips.map((chip) => (
                        <tr key={chip.id}>
                            <td>{chip.id}</td>
                            <td>{chip.phone_number}</td>
                            <td>{chip.pin}</td>
                            <td>{chip.pun}</td>
                            <td>{chip.punk}</td>
                            <td>{chip.operator}</td>
                            <td>
                                <button onClick={() => openModal(chip)}>✏️</button>
                                <button onClick={() => handleDelete(chip.id)}>🗑️</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {showModal && (
                <div className="chip-modal">
                    <div className="chip-modal-content">
                        <h3>{editing ? "Editar" : "Adicionar"} Chip</h3>

                        <input
                            name="phoneNumber"
                            value={form.phone_number || ""}
                            onChange={handleInputChange}
                            placeholder="Phone"
                        />

                        <input
                            name="pin"
                            value={form.pin || ""}
                            onChange={handleInputChange}
                            placeholder="PIN"
                        />

                        <input
                            name="pun"
                            value={form.pun || ""}
                            onChange={handleInputChange}
                            placeholder="PUN"
                        />

                        <input
                            name="punk"
                            value={form.punk || ""}
                            onChange={handleInputChange}
                            placeholder="PUNK"
                        />

                        <select
                            name="operator_id"
                            value={form.operator_id || ""}
                            onChange={handleInputChange}
                        >
                            {operators.map((op) => (
                                <option key={op.id} value={op.id}>
                                    {op.name}
                                </option>
                            ))}
                        </select>

                        <div className="chip-modal-actions">
                            <button onClick={handleSubmit}>
                                {editing ? "Salvar" : "Criar"}
                            </button>

                            <button onClick={() => setShowModal(false)}>
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChipCrud;